import { BrandSectionController } from './brand-section.controller'

function brandSection () {
  return {
    restrict: 'E',
    scope: {
      section: '=',
      first: '=',
      last: '='
    },
    templateUrl: '/brand/directives/brand-section/brand-section-directive.html?$$REVISION$$',
    controller: BrandSectionController
  }
}

export { brandSection }
